import { useContext } from "react";
import { TCTeamsFxContext } from "../components/TCTeamsContext";
import { useApi } from "./useApi";
import { logger } from "../Logger";
import { useLocation } from "react-router-dom";
import { UseTypeQueryResult } from "../types";
import { MethodType } from "../types/ApiRequest";
import config from "../config/config";
import { Constants } from "../common/constants";
/**
 * Get login URL
 */
export const useGetLoginUrl = (
  userAadOid: string,
  tokenSid: string
): UseTypeQueryResult<{ url: string }> => {
  const tcTeamsContext = useContext(TCTeamsFxContext);
  const search = useLocation().search;

  const sessionId = new URLSearchParams(search).get("sessionId") || "";
  const oldSessionId = tcTeamsContext?.teamcenter?.session?.sessionId || "";
  const userUid = tcTeamsContext?.teamcenter?.session?.userUid || "";
  const clientId = config.clientId || "";
  const appType = Constants.appType;

  const url = `${config.tcTeamsWebApiUrl}/auth/login/${encodeURIComponent(sessionId)}/${encodeURIComponent(clientId)}?authEndUri=${encodeURIComponent(
    "auth-tc-end.html"
  )}&sessionId=${encodeURIComponent(oldSessionId)}&userUid=${encodeURIComponent(userUid)}&tokenSid=${encodeURIComponent(tokenSid)}&userAadOid=${encodeURIComponent(userAadOid)}&appType=${encodeURIComponent(appType)}`;

  // As with Edge the value teamsContext.teamcenter.isAuthenticated is true even when the user is disconnected,
  // Instead of using the line below to enable the login  request
  // !teamsContext.teamcenter.isAuthenticated && userAadOid !== ''
  // we will use the one below
  // (!teamsContext.teamcenter.isAuthenticated || (window.navigator.userAgent.indexOf("Edg") !== -1)) && userAadOid !== ''
  // TODO: As it's more a turnaround than a fix, a new bug (#2549) has been created to identify the origin of the issue with Edge.
  // https://dev.azure.com/msft-siemens/Teamcenter-Teams/_workitems/edit/1663/?workitem=2549
  const enabled =
    (!tcTeamsContext?.teamcenter.isAuthenticated ||
      window.navigator.userAgent.indexOf("Edg") !== -1) &&
    userAadOid !== "";

  const response = useApi(
    {
      url: url,
      method: MethodType.GET,
      key: "login",
      enabled: enabled,
      action: "useGetLoginUrl",
    },
    logger
  );

  return {
    get url() {
      const redirectUri = response?.data?.redirectUri;
      return redirectUri;
    },
    ...response,
  };
};
